import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeProps as _normalizeProps, guardReactiveProps as _guardReactiveProps, renderSlot as _renderSlot, mergeProps as _mergeProps, createCommentVNode as _createCommentVNode, unref as _unref, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock } from "vue"

import { compact } from 'lodash';
import { Ref } from 'vue';

import {
  ColumnDefinition,
  Data,
  Sticky,
} from '@/components/_global/BalTable/types';

type Props = {
  columns: ColumnDefinition<any>[];
  onRowClick?: (data: any) => void;
  data: Ref<any>;
  link?: {
    to: string;
    getParams: (data: any) => Record<string, string>;
  } | null;
  sticky?: Sticky;
  isColumnStuck?: boolean;
  pinned?: boolean;
  noPadding?: boolean;
};


export default /*#__PURE__*/_defineComponent({
  props: {
    columns: null,
    onRowClick: null,
    data: null,
    link: null,
    sticky: null,
    isColumnStuck: { type: Boolean },
    pinned: { type: Boolean },
    noPadding: { type: Boolean }
  },
  setup(__props: any) {

const props = __props as {
  columns: ColumnDefinition<any>[];
  onRowClick?: (data: any) => void;
  data: Ref<any>;
  link?: {
    to: string;
    getParams: (data: any) => Record<string, string>;
  } | null;
  sticky?: Sticky;
  isColumnStuck?: boolean;
  pinned?: boolean;
  noPadding?: boolean;
}



function handleRowClick(data: Data) {
  if (props.link?.to) return;
  props.onRowClick && props.onRowClick(data);
}

// Need a method for horizontal stickiness as we need to
// check whether the table item belongs in the first column
function getHorizontalStickyClass(index: number) {
  if (index !== 0) return '';
  if (props.sticky === 'horizontal' || props.sticky === 'both') {
    return 'horizontalSticky';
  }
  return '';
}

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("tr", {
    class: _normalizeClass([
      'row-tr bg-white z-10 row-bg group',
      {
        'cursor-pointer': handleRowClick,
        'border-b dark:border-gray-700': __props.pinned,
      },
    ]),
    onClick: _cache[0] || (_cache[0] = ($event: any) => (handleRowClick(__props.data)))
  }, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.columns, (column, columnIndex) => {
      return (_openBlock(), _createElementBlock("td", {
        key: column.id,
        class: _normalizeClass([
        'text-' + column.align,
        getHorizontalStickyClass(columnIndex),
        __props.isColumnStuck ? 'isSticky' : '',
        'row-item',
        !props.noPadding ? 'row-item-padding' : '',
      ])
      }, [
        (__props.link)
          ? (_openBlock(), _createBlock(_component_router_link, {
              key: 0,
              to: {
          name: __props.link.to,
          params: __props.link.getParams(__props.data),
        }
            }, {
              default: _withCtx(() => [
                (column.Cell)
                  ? _renderSlot(_ctx.$slots, column.Cell, _normalizeProps(_mergeProps({ key: 0 }, __props.data)))
                  : (_openBlock(), _createElementBlock("div", {
                      key: 1,
                      class: _normalizeClass(_unref(compact)(['', 'text-' + column.align, column.cellClassName]))
                    }, _toDisplayString(typeof column.accessor === 'string'
              ? __props.data[column.accessor]
              : column.accessor(__props.data)), 3))
              ]),
              _: 2
            }, 1032, ["to"]))
          : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
              (column.Cell)
                ? _renderSlot(_ctx.$slots, column.Cell, _normalizeProps(_mergeProps({ key: 0 }, __props.data)))
                : (_openBlock(), _createElementBlock("div", {
                    key: 1,
                    class: _normalizeClass(_unref(compact)(['', 'text-' + column.align, column.cellClassName]))
                  }, _toDisplayString(typeof column.accessor === 'string'
              ? __props.data[column.accessor]
              : column.accessor(__props.data)), 3))
            ], 64))
      ], 2))
    }), 128))
  ], 2))
}
}

})